/**
 * jurisprudencia.ts — Pesquisa Jurisprudencial e o chat sobre ela (F8).
 */

import type { components } from './generated/api'
import { api } from './http'

export type PesquisaResumo = components['schemas']['PesquisaResumo']
export type DocumentoPesquisa = components['schemas']['DocumentoPesquisa']
export type MensagemChat = components['schemas']['MensagemChat']
export type GeracaoPesquisa = components['schemas']['GeracaoPesquisa']

export function listarPesquisas() {
  return api<{ pesquisas: PesquisaResumo[] }>('/api/v1/jurisprudencia')
}

export function criarPesquisa(consulta: string) {
  return api<GeracaoPesquisa>('/api/v1/jurisprudencia', {
    method: 'POST',
    body: { consulta },
  })
}

export function documentoPesquisa(id: number) {
  return api<DocumentoPesquisa>(`/api/v1/jurisprudencia/${id}`)
}

export function excluirPesquisa(id: number) {
  return api<{ removido: boolean }>(`/api/v1/jurisprudencia/${id}`, {
    method: 'DELETE',
  })
}

export function historicoChat(id: number) {
  return api<{ mensagens: MensagemChat[] }>(`/api/v1/jurisprudencia/${id}/chat`)
}

export function perguntarChat(id: number, mensagem: string) {
  return api<MensagemChat>(`/api/v1/jurisprudencia/${id}/chat`, {
    method: 'POST',
    body: { mensagem },
  })
}

export function limparChat(id: number) {
  return api<{ removido: boolean }>(`/api/v1/jurisprudencia/${id}/chat`, {
    method: 'DELETE',
  })
}

export function avaliarResposta(id: number, chatId: number, feedback: 'util' | 'nao_util') {
  return api<{ registrado: boolean }>(
    `/api/v1/jurisprudencia/${id}/chat/${chatId}`,
    { method: 'PATCH', body: { feedback } },
  )
}
